import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "Types";
import { createSlice } from "@reduxjs/toolkit";

export type MessageType = "info" | "warning" | "success" | "critical";

export interface MessageState {
  message: string | null;
  type?: MessageType | null;
  errorType?: string | null;
  showOnSnackbar?: boolean;
  failSilent?: boolean;
}

export const initialState: MessageState = {
  message: null,
  type: null,
  errorType: null,
  showOnSnackbar: true,
  failSilent: false,
};

export const messageSlice = createSlice({
  name: "message",
  initialState,
  reducers: {
    setMessage: (state: RootState, action: PayloadAction<MessageState>) => {
      Object.assign(state, {
        failSilent: false,
        ...action.payload,
        type: action.payload.type || "info",
      });
    },
    clearMessage: () => {
      return initialState;
    },
  },
});

export const { setMessage, clearMessage } = messageSlice.actions;
export const selectMessage = (state: RootState) => state.message;
export default messageSlice.reducer;
